import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/axiosConfig';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return <>{children}</>;
};
